import { error99, RetAPI, Serie } from '../../Utils/Types'
import { Api } from '../../Utils/api'
import { v4 as uuid } from 'uuid'
import { encode as base64_encode } from 'base-64'

export const SerieService = {

    GetAttributes: async (id?: string): Promise<RetAPI> => {

        const resp = await Api('SerieDocFiscal/attributes', 'get', { id })
        const attributes: Serie = {
            id: 0,
            num_doc: 0,
            modelo: 0,
            serie: 0,
            id_empresa: 0,
            dt_cadastro: '',
            id_user_insert: 0,
            name_user_insert: '',
            dt_last_update: '',
            name_user_last_update: ''
        }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: attributes
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.serie) {

                    attributes.id = resp.data.serie.id
                    attributes.num_doc = resp.data.serie.num_doc
                    attributes.modelo = resp.data.serie.modelo
                    attributes.serie = resp.data.serie.serie
                    attributes.id_empresa = resp.data.serie.id_empresa
                    attributes.dt_cadastro = resp.data.serie.dt_cadastro
                    attributes.id_user_insert = resp.data.serie.id_user_insert
                    attributes.name_user_insert = resp.data.serie.name_user_insert
                    attributes.dt_last_update = resp.data.serie.dt_last_update
                    attributes.name_user_last_update = resp.data.serie.name_user_last_update

                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: attributes
            }
        }

        return {
            error: false,
            data: attributes
        }

    },

    Save: async (serie: any): Promise<RetAPI> => {

        let id = ''

        if (serie.id) {
            id = serie.id.toString()
        }

        const resp = await Api('SerieDocFiscal/save', 'post', {

            num_doc: serie.num_doc,
            modelo: serie.modelo,
            serie: serie.serie,
            id

        })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',

                }
            }

            return {
                error: false,
                msg: 'Dados da serie gravados com sucesso',
                id: resp.data.serie.id,
                data: resp.data,
                dt_cadastro: resp.data.serie.dt_cadastro,
                dt_last_update: resp.data.serie.dt_last_update,
                name_user_insert: resp.data.serie.name_user_insert,
                name_user_last_update: resp.data.serie.name_user_last_update,

            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

    },

    Delete: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`SerieDocFiscal/delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    Filter: async (field: string, filter: string): Promise<RetAPI> => {

        const resp = await Api(`SerieDocFiscal/filter?${field}=${filter}`, 'get')
        const serie: Serie[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: serie
                }
            }

            if (resp.data.error && resp.data.error === '0') {
                resp.data.series.map((item: any) => {
                    return serie.push({

                        id: item.id,
                        num_doc: item.num_doc,
                        modelo: item.modelo,
                        serie: item.serie,
                        id_empresa: item.id_empresa,
                        dt_cadastro: item.dt_cadastro,
                        id_user_insert: item.id_user_insert,
                        name_user_insert: item.name_user_insert,
                        dt_last_update: item.dt_last_update,
                        name_user_last_update: item.name_user_last_update,


                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: serie
            }
        }

        return {
            error: false,
            data: serie,
        }

    },

    Relatorio: async (datai: string, dataf: string, modelo?: string, serie?: string, mostrar_excluidas?: string): Promise<RetAPI> => {

        const resp = await Api('SerieDocFiscal/Report/relatorio', 'get', { datai, dataf, modelo, serie, mostrar_excluidas })
        const serieDoc: any[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: serieDoc
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.seried.map((item: any) => {
                    return serieDoc.push({

                        id: item.id,
                        id_user_exclusao: item.id_user_exclusao,
                        dh_exclusao: item.dh_exclusao,
                        motivo_exclusao: item.motivo_exclusao,
                        name_user_delete: item.name_user_delete,
                        num_doc: item.num_doc,
                        modelo: item.modelo,
                        serie: item.serie,
                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: serieDoc
            }
        }

        return {
            error: false,
            data: serieDoc,
        }

    }

}
